import React from 'react'
import MainTitle from '../../../components/ui/MainTitle'
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useUpdateResource } from '../../../hooks/useUpdateResource';
import LoadingButton from '../../../components/form/LoadingButton';
import SubmitButton from '../../../components/form/SubmitButton';
import EmployeeForm, { EmployeeFormData } from '../../../components/admin/employees/EmployeeForm';
import { useRolesByAdmin } from '../../../hooks/admin/roles.admin';
import LoadingErrorState from '../../../components/ui/LoadingErrorState';

export default function AdminAddNewEmployee() {
    const { register, handleSubmit, formState: { errors } , setValue ,watch} = useForm<EmployeeFormData>();

    const {t} = useTranslation();
    const navigate = useNavigate();

   const { loading, updateResource } = useUpdateResource();
   const {data:roles , isError , isLoading} = useRolesByAdmin(false);
  
    const onSubmit = (data: EmployeeFormData) => {
      updateResource(`admin`, {phone:`966${data.phone}`,name:data.name, roleId:+data.roleId},
          "admin",{
              method: "POST",
              successMessage: t("createdSuccess"),
              invalidateQueries:["employees-by-admin"],
              navigateAfter: () => navigate(`/admin/employees`),
            });
    };
  return (
    <div className="p-4">
      <LoadingErrorState
      isError={isError}
      isLoading={isLoading}
      />
      <form onSubmit={handleSubmit(onSubmit)}  className="flex flex-col gap-4 w-full">
        <MainTitle title="add_new_employee" />
        {
            roles &&
            <>
                <EmployeeForm register={register} errors={errors} setValue={setValue} watch={watch} roles={roles}/>
                {
                    loading
                    ?
                    <LoadingButton/>
                    :
                    <SubmitButton label="create"/>
                } 
            </>
        }
      </form>
    </div>
  )
}
